module.exports = __webpack_public_path__ + "img/oog_ol.c96656d6.png";